import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from '../../services/commonservice';
import { QuestionService } from '../../services/questionservice';

// Import ISG Shared Components
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { dateValueFormatter } from '@mysrc/app/shared/utils/date-formatter';


@Component({
  selector: 'app-page-view-questions',
  standalone: true,
  imports: [AgGridAngular, CommonModule, FormsModule, ReactiveFormsModule, IsgGridComponent],
  templateUrl: './page-view-questions.component.html',
  styleUrl: './page-view-questions.component.scss',
  providers: [CommonService, QuestionService]
})

export class PageViewQuestionsComponent extends BaseHttpReqRespService {
  success: boolean = false;
  isExpanded = false;
  public mainQuestionList!: mainQuestion[];
  myAppUrl: any;
  public questionsToDelete: string[] = [];
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  errorMessage: any;
  public questionReference!: string;
  public question!: string;
  successOrFailureMessage: string = '';
  public fromPage: string = 'View Question';
  public searchQuestionCategoryId: number = 0;
  public showCopyModal = false;
  public showMappingModal = false;
  public showDeleteModal = false;
  showQuestionTypes = false;

  currentFolderId!: number;
  public selectedQuestionList: number[] = [];
  mapQuestionForm!: FormGroup;
  private gridApi: any[] = [];
  public UnmappedFolderQuestionList!: mainQuestion[];
  public folderList!: folderDetails[];
  public tmpFolderLists!: folderDetails[];
  public questionList!: questionDetails[];
  public unmappedFolderQuestionList!: questionDetails[];
  defaultList = new BehaviorSubject<questionDetails[]>([]);
  public questionCategoryList: questionCategory[] = [];
  public mapQuestionsRowSelect: string[] = [];
  folderId: any;
  public myList = [];
  folList: folderDetails[] = [];
  list!: any[];
  currentSelectedQuestionId!: number;
  public currentSelectedQuestionName!: string;
  copyQuestionForm!: FormGroup;
  public oktaTokenDetails!: oktaToken;


  // ISG Grid configurations for consistent styling
  mainGridConfig: Partial<IsgGridConfig> = {
    height: '400px',
    pagination: false,
    rowSelection: 'multiple',
    autoSizeColumns: true
  };

  mapQuestionsGridConfig: Partial<IsgGridConfig> = {
    height: '400px',
    pagination: false,
    rowSelection: 'multiple',
    autoSizeColumns: true
  };

  constructor(http: HttpClient
    , @Inject(OKTA_AUTH) private oauth: OktaAuth
    , private EncrDecr: EncrDecrService
    , private commonService: CommonService
    , private route: ActivatedRoute
    , private renderer: Renderer2
    , private formBuilder: FormBuilder
    , private _router: Router
    , private questionSerivce: QuestionService
    , @Inject('CONFIG_SETTINGS') configSettings: any) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl = this.baseUrl;
  }

  redirectMenu(type: any) {
    this.currentFolderId = this.route.snapshot.queryParams["questionReference"] || '-1';
    let folderName = this.route.snapshot.queryParams["question"] || '';
    if (type == 'matrix')
      this._router.navigate(['/questionmatrix'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'description')
      this._router.navigate(['/descriptionType'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'textInput')
      this._router.navigate(['/inputType'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'pickList')
      this._router.navigate(['/picklistquestion'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'MCR')
      this._router.navigate(['/multipleresponse'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'MCQ')
      this._router.navigate(['/multiplechoice'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'slider')
      this._router.navigate(['/slider'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'constantsum')
      this._router.navigate(['/constantsum'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'rankingsort')
      this._router.navigate(['/rankingsort'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
    else if (type == 'datetime')
      this._router.navigate(['/datetimeType'], { queryParams: { 'questionId': 0, 'folderId': this.currentFolderId, 'folderName': folderName } });
  }

  ngOnInit() {


    this.questionReference = this.route.snapshot.queryParams["questionReference"];
    this.question = this.route.snapshot.queryParams["question"];
    //this.route.params.subscribe(params => {
    //  this.questionReference = params['questionReference'];    
    //  this.question = params['question'];
    //});
    this.getMainQuestionList();
    //this.getUnmappedQuestionList();
    this.getQuestionCategoryList();
    this.getFolderList();

    this.copyQuestionForm = this.formBuilder.group({
      'question': new FormControl('', Validators.required),
      sourceQuestionId: 0,
    });

    //this.getAccessToken();

    this.mapQuestionForm = this.formBuilder.group({
      'folderId': new FormControl(null, Validators.required),
      'questionCategoryId': new FormControl(null, null),
    });

  }

  loadQuestionByFolder() {
    this.selectedQuestionList = [];
    let folderId = this.mapQuestionForm.get('folderId')?.value ?? null;
    this.currentFolderId = folderId
    this.loadQuestion(folderId)
    this.mapQuestionForm.patchValue({
      questionCategoryId: ""
    });
  }

  loadQuestion(tempFolderId: any) {
    let parameter = "?folderId=" + tempFolderId.toString() + "&workSpaceid=" + this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTIONS_BY_FOLDER_VIEW_QUESTIONS + parameter).subscribe(result => {
      this.questionList = result;
      this.defaultList.next(result);
    }, error => alert(error));
  }

  getUnmappedQuestionList() {
    let parameter = "?folderId=" + this.questionReference + "&workSpaceid=" + this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.UNMAPPED_QUESTION_LIST + parameter).subscribe(result => {
      this.UnmappedFolderQuestionList = result;
    });
  }

  getMainQuestionList() {
    this.questionSerivce.getMainQuestionList(this.questionReference).subscribe({
      next: (result: any[]) => {
        this.mainQuestionList = result;
      }
    })
  }

  getFolderList() {

    //const httpOptions = {
    //  headers: new HttpHeaders({
    //    'Content-Type': 'application/x-www-form-urlencoded',
    //  }),
    //};
    //let tmpFolderId = this.questionReference;
    //let parm = "workSpaceid=" + this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    //this.commonService.httpPost(parm, this.myAppUrl + this._getFolderListUrl, httpOptions).subscribe(result => {
    //  this.folderList = result;
    //}, error => alert(error));



    this.questionSerivce.getFolderList(this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '')).subscribe({
      next: (result: any[]) => {
        this.folderList = result;
      }
    })

  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));
  }

  onQuestionCategoryChange() {
    this.selectedQuestionList = [];
    const questionCategoryId = this.mapQuestionForm.get('questionCategoryId')?.value ?? null;
    this.loadQuestionByCategory(questionCategoryId);
    this.mapQuestionForm.patchValue({
      folderId: - 1,
    });
  }

  loadQuestionByCategory(questionCategoryId: any) {
    this.folderId = this.currentFolderId;
    let params = "?folderId=" + this.folderId ?? '0' + "&workSpaceid=" + this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '') + "&questionCategoryId=" + questionCategoryId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };

    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTIONS_BY_CATEGORY_VIEW_QUESTIONS + params).subscribe(result => {
      this.defaultList.next(result);
    }, error => console.error(error));
  }

  BackUrl() {
    this._router.navigate(['/question']);
  }
  onFolderGridReady(params: any) {
    params.api.sizeColumnsToFit();
  }
  unmappedQuestionGrid(params: any) {
    params.api.sizeColumnsToFit();
  }
  columnDefs: ColDef[] = [
    { headerName: '', field: 'rowSelect', resizable: true, width: 50, suppressMenu: true, checkboxSelection: true, headerCheckboxSelection: true, sortable: false },
    { headerName: 'QuestionId', field: 'questionReference', hide: true, resizable: true },
    { headerName: 'Question Text', field: 'question', width: 550, cellRenderer: this.linkRenderer.bind(this), resizable: true, sortable: false },
    { headerName: 'Type', field: 'questionType', width: 150, resizable: true },
    { headerName: 'Created Date', field: 'createdDate', width: 120, resizable: true, valueFormatter: dateValueFormatter },
    { headerName: 'Created By', field: 'createdByName' },
    { headerName: 'Actions', field: 'value', width: 100, cellRenderer: this.FolderQuestionActionsRenderer.bind(this), resizable: true },

  ];

  colDefForUnmappingQuestions: ColDef[] = [
    { headerName: '', field: 'rowSelect', width: 80, suppressMenu: true, checkboxSelection: true, headerCheckboxSelection: true, sortable: false },
    { headerName: 'QuestionId', field: 'questionReference', hide: true },
    { headerName: 'Question Text', field: 'question', width: 760, cellRenderer: this.linkRenderer.bind(this) },
    { headerName: 'Type', field: 'questionType', width: 230 }
  ];

  CopyQuestion() {
    let data = JSON.stringify(this.copyQuestionForm.value);
    this.questionSerivce.copyQuestion(data, this.questionReference).subscribe(result => {
      this.mainQuestionList = result.questionList;
      if (result.status == 'Yes') {
        this.successOrFailureMessage = "Question has been copied successfully.";

      }
      else {
        this.successOrFailureMessage = "Error occurred while trying to copy the specified question.Please try again..";
      }
      this.messageTimeout();
      this.copyQuestionForm.reset();
      this.questionsToDelete = [];
      this.CloseModal();

    }, error => console.error(error));

  }
  FolderQuestionActionsRenderer(params: any) {
    const mainElement = this.renderer.createElement('div');
    this.renderer.setStyle(mainElement, 'justify', 'content:center');

    //Preview Question Action
    const previewAnchor = this.renderer.createElement('a');
    const previewIcon = this.renderer.createElement('i');
    previewIcon.setAttribute('class', 'fa fa-eye anchor-cursor p-2');
    previewIcon.setAttribute('title', 'Preview Question');
    this.renderer.appendChild(previewAnchor, previewIcon);
    this.renderer.appendChild(mainElement, previewAnchor);
    var questionReference = params.data.questionReference;
    var question = params.data.question;
    this.renderer.listen(previewAnchor, 'click', () => {
      this._router.navigate(['previewquestion', { questionId: questionReference, folderId: this.questionReference, folderName: this.question }]);
    });

    //Language Settings for the question
    if (params.data.questionType !== "Folder") {
      const langSettingsAnchor = this.renderer.createElement('a');
      const langSettingsIcon = this.renderer.createElement('i');
      langSettingsIcon.setAttribute('class', 'fa fa-cogs anchor-cursor p-2');
      langSettingsIcon.setAttribute('title', 'Question Language Settings');
      this.renderer.appendChild(langSettingsAnchor, langSettingsIcon);
      this.renderer.appendChild(mainElement, langSettingsAnchor);
      var questionReference = params.data.questionReference;
      var question = params.data.question;
      this.renderer.listen(langSettingsAnchor, 'click', () => {
        this._router.navigate(['/questionlanguagesettings'], { queryParams: { questionId: questionReference, folderId: this.questionReference, folderName: this.question } });
      });
    }

    if (params.data.questionType !== "Folder") {
      const element = this.renderer.createElement('a');
      const elementI = this.renderer.createElement('i');
      elementI.setAttribute('class', 'fa  fa-copy anchor-cursor');
      this.renderer.appendChild(element, elementI);
      this.renderer.appendChild(mainElement, element);
      this.renderer.listen(element, 'click', () => {
        this.currentSelectedQuestionId = params.data.questionReference;
        this.currentSelectedQuestionName = params.data.question;
        this.copyQuestionForm.patchValue({
          sourceQuestionId: params.data.questionReference,
          question: 'Copy of ' + params.data.question,
        });
        this.showCopyModal = true; // Show modal
      });
    }

    return mainElement;
  }
  CloseModal() {
    this.showCopyModal = false;
    this.showMappingModal = false;
  }
  PreviewQuestionCellRenderer(params: any) {
    const eSpan = this.renderer.createElement('a');
    const ielement = this.renderer.createElement('i');
    this.renderer.appendChild(eSpan, ielement);
    this.renderer.setAttribute(eSpan, 'class', 'fa  fa-eye anchor-cursor');
    var questionReference = params.data.questionReference;
    var question = params.data.question;
    this.renderer.listen(eSpan, 'click', () => {
      this._router.navigate(['/previewquestion'], { queryParams: { questionId: questionReference, folderId: this.questionReference, folderName: this.question } });
    });
    return eSpan;

  }

  linkRenderer(params: any) {

    const element = this.renderer.createElement('a');
    const text = this.renderer.createText(params.data.question);
    this.renderer.setAttribute(element, 'class', "anchor-cursor");
    this.renderer.appendChild(element, text);

    let questionId = params.data.questionReference;
    let folderId = this.route.snapshot.queryParams["questionReference"] || '-1';
    let folderName = this.question;
    let type = params.data.questionType;
    this.renderer.listen(element, 'click', () => {

      if (type == 'Matrix')
        this._router.navigate(['/questionmatrix'], { queryParams: { 'questionId': questionId, 'folderId': folderId, 'folderName': folderName } });
      else if (type == 'Description')
        this._router.navigate(['/descriptionType'], { queryParams: { 'questionId': questionId, 'folderId': this.questionReference, 'folderName': this.question } });
      else if (type == 'TextInput')
        this._router.navigate(['/inputType'], { queryParams: { 'questionId': questionId, 'folderId': this.questionReference, 'folderName': this.question } });
      else if (type == 'Picklist')
        this._router.navigate(['/picklistquestion'], { queryParams: { 'questionId': questionId, 'folderId': this.questionReference, 'folderName': this.question } });
      else if (type == 'MultipleResponse')
        this._router.navigate(['/multipleresponse'], { queryParams: { 'questionId': questionId, 'folderId': this.questionReference, 'folderName': this.question } });
      else if (type == 'MultipleChoice')
        this._router.navigate(['/multiplechoice'], { queryParams: { 'questionId': questionId, 'folderId': this.questionReference, 'folderName': this.question } });
      else if (type == 'Slider')
        this._router.navigate(['/slider'], { queryParams: { 'questionId': questionId, 'folderId': this.questionReference, 'folderName': this.question } });
      else if (type == 'ConstantSum')
        this._router.navigate(['/constantsum'], { queryParams: { 'questionId': questionId, 'folderId': this.questionReference, 'folderName': this.question } });
      else if (type == 'RankingSort')
        this._router.navigate(['/rankingsort'], { queryParams: { 'questionId': questionId, 'folderId': this.questionReference, 'folderName': this.question } });
    });
    return element;
  }
  onRowChecked(params: any) {
    if (params.node.selected) {
      this.questionsToDelete.push(params.data.questionReference + '~' + params.data.questionType);
    }
    else {
      var index = this.questionsToDelete.indexOf(params.data.questionReference + '~' + params.data.questionType);
      if (index !== -1) this.questionsToDelete.splice(index, 1);
    }
  }

  onRowCheckedMapQuestion(params: any) {
    if (params.node.selected) {
      this.mapQuestionsRowSelect.push(params.data.questionReference);
    }
    else {
      this.mapQuestionsRowSelect.splice(this.mapQuestionsRowSelect.indexOf(params.data.questionReference), 1);
    }
  }

  mapQuestionsToFolderGrid() {
    var concatenated = "";
    for (var i = 0; i < this.mapQuestionsRowSelect.length; i++) {
      if (this.mapQuestionsRowSelect[i] != undefined) {
        if (concatenated == "") {
          concatenated = this.mapQuestionsRowSelect[i].toString();
        }
        else {
          concatenated = concatenated + "," + this.mapQuestionsRowSelect[i].toString();
        }
      }
    }
    let selectedQuestionIdList = "?selectedQuestionIdList=" + concatenated + "&folderId=" + this.questionReference + "&workSpaceid=" + this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpGet('', this.myAppUrl + '/' + this.QUESTION_ENDPOINT.MAP_QUESTION_TO_FOLDER + selectedQuestionIdList).subscribe(result => {
      this.mainQuestionList = result;
      this.gridApi = [];
      this.mapQuestionsRowSelect = [];
      window.setTimeout(() => {
        this.successOrFailureMessage = '';

      }, 5000);

    }, error => console.error(error));
  }

  deleteQuestions() {
    let concatenatedDelete = "";
    for (var i = 0; i < this.questionsToDelete.length; i++) {
      concatenatedDelete = concatenatedDelete + this.questionsToDelete[i] + ",";
    }
    if (concatenatedDelete == '') return '';
    else {
      var model = "/" + concatenatedDelete + "/2";// do not accept hard code workspace Id
      this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.DELETE + model).subscribe(result => {
        //this.mainQuestionList = result.listOfMainQuestions;
        if (result.deletedStatus.toLowerCase() == "yes") {
          this.successOrFailureMessage = "Question/Folder Deleted Successfully";
        }
        else if (result.deletedStatus.toLowerCase() == "no") {
          this.successOrFailureMessage = "Cannot delete Question/Folder because there may be some Survey/Section dependency. ";
        }
        else {
          this.successOrFailureMessage = "Error occurred while deleting an question from the repository";
        }
        this.closeDeleteModal();
        this.messageTimeout();
        this.getMainQuestionList();
        this.questionsToDelete = [];
      }, error => console.error(error));

    }
    return '';

  }
  messageTimeout() {
    window.setTimeout(() => {
      this.successOrFailureMessage = '';
    }, 3200);
  }

  unMappedQuestionList() {
    this.selectedQuestionList = [];
    let tempDefaultFolderId = -1;
    this.currentFolderId = tempDefaultFolderId;
    this.mapQuestionForm.patchValue({
      folderId: - 1,
      questionCategoryId: ""
    });

    this.loadQuestion(this.currentFolderId);

    this.showMappingModal = true;
  }
  openDeleteModal() {
    this.showDeleteModal = true;
  }
  closeDeleteModal() {
    this.showDeleteModal = false;
  }

  toggleQuestionTypes() {
    this.showQuestionTypes = !this.showQuestionTypes;
  }
}

interface mainQuestion {
  questionReference: string,
  description: string;
  questionTypeId: string,
  questionType: string,
}

interface oktaToken {
  accessToken: string;
  apiHostName: string;
}

interface folderDetails {
  folderId: number,
  folderName: string
}
interface questionDetails {
  questionReference: number,
  question: string,
  questionType: string,
  folderId: number,
  folderName: string,
  isMandatory: boolean,
  questionPrefix: string;
  unmappedFolderQuestionList: string;
}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}













